import { useState, useEffect } from 'react';
import './Proxy.css';
import AddProxyModal from '../components/AddProxyModal';
import EditProxyModal from '../components/EditProxyModal';
import { supabase } from '../supabaseClient';

function Proxy() {
  const [proxies, setProxies] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [editProxy, setEditProxy] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchProxies() {
      setIsLoading(true);
      setError(null);
      const { data, error } = await supabase.from('proxie').select('*');
      if (error) {
        setError('Erro ao buscar proxies');
        setProxies([]);
      } else {
        setProxies(data);
      }
      setIsLoading(false);
    }
    fetchProxies();
  }, []);

  const handleAddProxy = async (proxy) => {
    setIsLoading(true);
    setError(null);
    const { error } = await supabase.from('proxie').insert([{
      host: proxy.host,
      port: proxy.port,
      login: proxy.login,
      password: proxy.password
    }]);
    if (error) {
      setError('Erro ao adicionar proxy');
    } else {
      // Atualiza a lista após adicionar
      const { data: updatedData } = await supabase.from('proxie').select('*');
      setProxies(updatedData || []);
    }
    setIsLoading(false);
  };

  const handleEditProxy = (proxy) => {
    setEditProxy(proxy);
  };

  const handleSaveEditProxy = async (proxy) => {
    setIsLoading(true);
    setError(null);
    const { error } = await supabase.from('proxie').update({
      host: proxy.host,
      port: proxy.port,
      login: proxy.login,
      password: proxy.password
    }).eq('id', proxy.id);
    if (error) {
      setError('Erro ao editar proxy');
    } else {
      const { data: updatedData } = await supabase.from('proxie').select('*');
      setProxies(updatedData || []);
    }
    setEditProxy(null);
    setIsLoading(false);
  };

  const handleDeleteProxy = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este proxy?')) return;
    setIsLoading(true);
    setError(null);
    const { error } = await supabase.from('proxie').delete().eq('id', id);
    if (error) {
      setError('Erro ao excluir proxy');
    } else {
      const { data: updatedData } = await supabase.from('proxie').select('*');
      setProxies(updatedData || []);
    }
    setIsLoading(false);
  };

  const renderSenha = (senha) => {
    if (!senha) return '-';
    
    return '••••' + senha.slice(-4); 
  };

  return (
    <div className="proxy-page-container">

      <div className="section-container">
        <div className="main-header">
          <h2>Gerenciamento de Proxies</h2>
          <button onClick={() => setModalOpen(true)} className="add-button">
            <span>Adicionar Proxy</span>
          </button>
        </div>
        <div className="content-area">
          {isLoading ? (
            <div>Carregando...</div>
          ) : error ? (
            <div style={{ color: 'red' }}>{error}</div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Host</th>
                  <th>Porta</th>
                  <th>Login</th>
                  <th>Senha</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {proxies.map(proxy => (
                  <tr key={proxy.id}>
                    <td>{proxy.host}</td>
                    <td>{proxy.port}</td>
                    <td>{proxy.login || '-'}</td>
                    <td>{renderSenha(proxy.password)}</td>
                    <td className="actions-cell">
                      <button className="action-button edit" onClick={() => handleEditProxy(proxy)}>Editar</button>
                      <button className="action-button delete" onClick={() => handleDeleteProxy(proxy.id)}>Excluir</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <AddProxyModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onAdd={handleAddProxy}
      />
      <EditProxyModal
        proxy={editProxy}
        isOpen={!!editProxy}
        onClose={() => setEditProxy(null)}
        onSave={handleSaveEditProxy}
      />
    </div>
  );
}

export default Proxy;